import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import ModifierGroupForm from '../../../ModifierGroups/ModifierGroupForm/ModifierGroupForm';
import { closeItemModal } from '../../../../../actions/siteadmin/modalActions';

class AddModifierModal extends React.Component {
  static defaultProps = {
    setShow: false
  }

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      setShow: false
    };
  }

  componentDidMount() {
    const { isItemModalOpen } = this.props;
    if (isItemModalOpen === true) {
      this.setState({ setShow: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { isItemModalOpen } = nextProps;

    if (isItemModalOpen === true) {
      this.setState({ setShow: true });
    } else {
      this.setState({ setShow: false });
    }
  }

  render() {
    const { closeItemModal, menuId, subMenuId, from } = this.props;
    const { setShow } = this.state;
    let initialValues = {
      menuId,
      subMenuId,
      modifierItems: [{
        modifierItemName: null,
        modifierItemPrice: null
      }],
      isActive: "true",
      modifierType: "1"
    }
    return (
      <div>
        <Modal size={'xl'} show={setShow} onHide={closeItemModal} className={'listItemModal', 'addModifierGroupModal'}>
          <Modal.Body>
            <ModifierGroupForm from={from} initialValues={initialValues} />
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

const mapState = (state) => ({
  isItemModalOpen: state?.modalStatus?.isItemModalOpen,
  menuId: state?.modalStatus?.menuId,
  subMenuId: state?.modalStatus?.subMenuId,
});

const mapDispatch = {
  closeItemModal,
};

export default connect(mapState, mapDispatch)(AddModifierModal);
